import { INLINE_LINK } from '@/components/bedrock';
import { useT } from '@/core/I18nProvider';

import type { ReactElement } from 'react';

/**
 * The closing sections of `/trust` — the related-documents cross-reference and
 * the contact section. Split from its page to keep that component under the
 * ~300-line ceiling (`.claude/rules/architecture.md`), following the
 * `TermsFooterSections` precedent in this directory. Purely presentational,
 * same keys, imports nothing back from its parent.
 */
export function TrustHubFooterSections(): ReactElement {
  const { t } = useT();
  return (
    <>
      <section aria-labelledby="topic-languages" className="mb-10">
        <h2
          id="topic-languages"
          className="mb-3 mt-11 scroll-mt-[calc(var(--bd-nav-h)+22px)] text-[1.45rem] font-semibold leading-[1.15] tracking-[-0.032em] text-[color:var(--bd-ink)]"
        >
          {t('trusthub.languages.heading')}
        </h2>
        <p>{t('trusthub.languages.body')}</p>
      </section>

      <section aria-labelledby="topic-contact">
        <h2
          id="topic-contact"
          className="mb-3 mt-11 scroll-mt-[calc(var(--bd-nav-h)+22px)] text-[1.45rem] font-semibold leading-[1.15] tracking-[-0.032em] text-[color:var(--bd-ink)]"
        >
          {t('trusthub.contact.heading')}
        </h2>
        <ul className="list-disc space-y-1 ps-6">
          <li>
            {t('trusthub.contact.procurement')}{' '}
            <a className={INLINE_LINK} href="mailto:admin@syncanix.com">
              admin@syncanix.com
            </a>
            .
          </li>
          <li>
            {t('trusthub.contact.dsar')}{' '}
            <a className={INLINE_LINK} href="mailto:admin@syncanix.com">
              admin@syncanix.com
            </a>
            .
          </li>
          <li>
            {t('trusthub.contact.security')}{' '}
            <a className={INLINE_LINK} href="mailto:admin@syncanix.com">
              admin@syncanix.com
            </a>
            .
          </li>
        </ul>
      </section>
    </>
  );
}
